<template>
  <div
    v-if="colorVariants.length"
    class="color-variant"
  >
    <AppLink
      v-for="(colorVariant, index) in limitedColorVariants"
      :key="index"
      :to="colorVariant.url"
      class="color-variant__swatch"
      :class="[
        colorVariant.stockStatus ? 'in-stock' : 'out-of-stock',
        colorVariant.url === props.activeUrl ? 'active' : '',
      ]"
      :style="swatch(colorVariant?.color?.swatch, colorVariant?.color?.label)"
      :aria-label="colorVariant?.color?.label || ''"
    >
      &nbsp;{{ colorVariant?.color?.label || '' }}
    </AppLink>

    <span
      v-if="colorVariants.length > limitedColorVariants.length"
      class="color-variant__more"
    >
      + {{ colorVariants.length - limitedColorVariants.length }}
    </span>
  </div>
</template>

<script setup lang="ts">
export interface Props {
  colorVariants: {
    url: string
    color: {
      label: string
      swatch: string
    }
    stockStatus?: boolean
  }[]
  activeUrl?: string
  limit?: number
}

const props = withDefaults(defineProps<Props>(), {
  limit: 4,
})

const { public: config } = useRuntimeConfig()
const swatch = (swatch: string | undefined, label: string | undefined) => {
  const swatchPath = config.baseDomain + '/media/attribute/swatch'

  if (!swatch) return ''

  const multicolorStyle = 'background-image: linear-gradient(#ffff00 0 50%, #ff69b4 50% 100%), linear-gradient(#00aa00 0 50%, #0000ff 50% 100%); background-size: 50% 100%, 50% 100%; background-position: left center, right center; background-repeat: no-repeat;'

  if (label?.toLowerCase() === 'multicolor') {
    return multicolorStyle
  }

  const parts = swatch.split(',').map(s => s.trim())

  if (parts.every(p => p.startsWith('#'))) {
    if (parts.length === 1) return `background-color: ${parts[0]}`
    if (parts.length > 2) return multicolorStyle
    const stop = 100 / parts.length
    const gradient = parts.map((color, i) => `${color} ${i * stop}% ${(i + 1) * stop}%`).join(', ')
    return `background-image: linear-gradient(to right, ${gradient}); background-size: 100% 100%;`
  }

  return `background-image: url(${swatchPath + swatch}); background-size: 1.3rem 1.3rem; background-position: center center; border: 0;`
}

const limitedColorVariants = computed(() =>
  props.colorVariants.slice(0, props.colorVariants.length > props.limit ? props.limit - 1 : props.colorVariants.length),
)
</script>

<style>
@import url("~layers/app/components/Product/ColorVariant.css");
</style>
